import UsersRepository from "../UsersRepository";

export default class FormatUserUseCase {
  public static doFormat(usersRepository: UsersRepository, userId: string) {
    const user = usersRepository.getUserById(userId);
    if (user) return user.name + " " + user.surname;
    else "utente " + userId + " non trovato";
  }
}
